import {
  ACCESS_TOKEN_EXPIRED_MESSAGE,
  INVALID_ACCESS_TOKEN_MESSAGE,
  JWT_EXPIRED,
} from '../../constants/errors';

export const isTokenExpired = (
  data: { fault?: { faultstring: string }, message?: string } | null | undefined,
) => data?.fault?.faultstring === INVALID_ACCESS_TOKEN_MESSAGE
    || data?.fault?.faultstring === ACCESS_TOKEN_EXPIRED_MESSAGE
    || data?.message?.includes(JWT_EXPIRED);
